import LeftBodyCardGlobal from "./leftBodyCard/leftBodyCard";
import RightBodyCardGlobal from "./rightBodyCard/rightBodyCard";
import './bodyCardGlobal.sass';

/**
 * Componente principal que renderiza el cuerpo de la tarjeta global (fútbol, NFL, etc.).
 * Divide la vista en dos partes: lado izquierdo (equipos) y lado derecho (marcador y momios).
 */
export default function BodyCardGlobal({ data, flagMomios, patrocinador }) {
  return (
    <div className="card-global__body">
      {/* Lado izquierdo: nombres e imágenes de los equipos */}
      <LeftBodyCardGlobal data={data} />

      {/* Lado derecho: marcador y momios */}
      <RightBodyCardGlobal data={data} flagMomios={flagMomios} patrocinador={patrocinador} />
    </div>
  )
}